import script from "./BidViewDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewDescription.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewDescription.vue?vue&type=style&index=0&id=c5098bf2&lang=scss"

const __exports__ = script;

export default __exports__